<template>
  <div
    data-app="true"
    class="v-application v-application--is-ltr theme--light full-sidebar"
    id="materialpro"
  >
    <div class="v-application--wrap">
      <div
        data-app="true"
        class="v-application v-application--is-ltr theme--light"
        id="app"
      >
        <div class="v-application--wrap">
          <section class="container fill-height justify-center" id="login">
            <div class="row justify-center">
              <div class="col-sm-8 col-lg-11 col-xl-7 col">
                <div class="elevation-4 v-card v-sheet theme--light pa-1">
                  <v-row no-gutters>
                    
                    <v-hover v-slot:default="{ hover }">
                        <div
                          class="info d-none d-md-flex align-center justify-center col-lg-7 col rounded-sm"
                        >

                          <v-carousel
                            show-arrows-on-hover
                            hide-delimiter-background
                            :cycle="!hover"
                            :interval="10000"
                          >
                            <v-carousel-item>
                              <div class="d-none d-sm-block">
                                <div class="d-flex align-center pa-10">
                                  <div>
                                    <h3
                                      class="display-1 white--text font-weight-medium"
                                    >
                                      Pharmcenter.kz
                                    </h3>
                                    <h5 class="subtitle-3 mb-2 mt-2 white--text">
                                        Онлайн-платформа для автоматизации закупа аптек, продвижения производителей и взаимодействия с дистрибьюторами.
                                    </h5>
                                    <hr>
                                    <h5 class="mt-4 white--text">Узнать больше о продуктах компании</h5>
                                   <v-btn
                                      v-for="item in solutions"
                                      :key="item.title"
                                      :href="item.url"
                                      target="_blank"
                                      outlined
                                      block
                                      height="62"
                                      class="product-btn ma-2 px-4"
                                    >
                                      <div class="product-btn__content">
                                        <div>
                                          <div class="product-btn__title">
                                            {{ item.title }}
                                            <span>
                                              {{ item.subtitle }}
                                            </span>
                                          </div>

                                          <div class="product-btn__subtitle">
                                            {{ item.description }}
                                          </div>
                                        </div>

                                        <v-icon class="product-btn__icon">
                                          mdi-chevron-right
                                        </v-icon>
                                      </div>
                                    </v-btn>
                                  </div>
                                </div>
                              </div>
                            </v-carousel-item>
                            <v-carousel-item>
                              <div class="pa-10">
                                <h2
                                  class="display-1 white--text font-weight-medium"
                                >Менеджера по работе с клиентами:</h2>
                              </div>
                              <v-row no-gutters>
                                <v-col cols="12">
                                  <v-simple-table dense class="my-1 ml-10">
                                    <template v-slot:default>
                                      <thead class="info">
                                        <tr>
                                          <th class="text-left white--text">ФИО</th>
                                          <th class="text-left white--text">Номер</th>
                                        </tr>
                                        </thead>
                                        <tbody class="info">
                                          <tr class="line-info"
                                            v-for="item in managerInfo"
                                            :key="item.FullName"
                                          >
                                            <td class="text-left white--text"><span>{{ item.FullName }}</span></td>
                                            <td class="text-left white--text"><span>{{ item.Phone }}</span></td>
                                          </tr>
                                        </tbody>
                                    </template>
                                  </v-simple-table>
                                </v-col>
                              </v-row>
                            </v-carousel-item>
                          </v-carousel>
                        </div>
                      </v-hover>


                    <!-- Вход в систему -->

                    <div class="col-lg-5 col" v-if="show">                     
                      <div class="pa-7">
                        <v-img
                        
                          contain
                          src="../../../public/logo.png"
                        ></v-img>
                        <!-- <h2
                          class="font-weight-bold mt-4 blue-grey--text text--darken-2"
                        >
                          Вход в систему
                        </h2> -->

                        <br />
                        <br />
                        <form class="v-form">
                          <v-text-field
                            label="Логин"
                            name="login"
                            prepend-icon="mdi-account"
                            type="text"
                            v-model.trim="account.login"
                            :rules="[rules.required]"
                            :autofocus="true"
                            :error-messages="modelState['Login']"
                            @keyup.enter="Authenticate"
                          />
                          <v-text-field
                            id="password"
                            label="Пароль"
                            name="password"
                            prepend-icon="mdi-lock"
                            v-model.trim="account.password"
                            :rules="[rules.required]"
                            :append-icon="
                              showPassword ? 'mdi-eye' : 'mdi-eye-off'
                            "
                            @click:append="showPassword = !showPassword"
                            :type="showPassword ? 'text' : 'password'"
                            :error-messages="modelState['Password']"
                            @keyup.enter="Authenticate"
                          />

                          <v-btn
                            x-small
                            text
                            color="primary"
                            style="float: right"
                            @click="show = false"
                            >Забыли пароль?</v-btn
                          >
                          <br />
                          <br />
                          <v-btn
                            outlined
                            dark
                            block
                            color="primary"
                            @click="Authenticate"
                            :loading="loading"
                            depressed
                            large
                            >Вход в систему</v-btn
                          >
                        </form>
                        <template>

                          <v-container>
                            <v-row>
                                <v-col cols="6">
                                  <v-btn 
                                    x-small
                                    text
                                    color="primary"
                                    style="float: left"
                                    :href="'https://pharmcenter.bitrix24site.ru/crm_form_2zuzq/'"
                                  >
                                    Регистрация
                                  </v-btn>
                                </v-col>

                                <v-col cols="6">
                                  <v-btn 
                                    x-small
                                    text
                                    color="primary"
                                    style="float: right" 
                                    @click="dialogAboutUs = true"
                                  >
                                    О компании
                                  </v-btn>
                                </v-col>
                              </v-row>
  
                              <v-dialog v-model="dialogAboutUs" max-width="900px">
                                <v-card>
                                  <v-card-text class="pt-10">
                                    <div>
                                        <img src="../../assets/img/infografika.png" alt="Инфографика о компании" />
                                    </div>
                                    <div class="main-first-paragraph">
                                      <p>
                                          Компания PharmIT — ваш надежный партнер в сфере автоматизации фармацевтического бизнеса. Мы специализируемся на создании
                                          современных IT-решений, которые упрощают процесс взаимодействия между аптеками, дистрибьюторами и медицинскими представителями.
                                      </p>
                                  </div>
                                  <div class="mission-paragraph">
                                      <p>
                                          <span class="special-word">Наша миссия</span> — повысить эффективность и прозрачность процесса заказа лекарственных препаратов, предоставляя
                                          удобные инструменты для всех участников фармацевтической цепочки.
                                      </p>
                                  </div>
                                  <div class="main-third-paragraph">
                                      <div class="icon-title-wrapper">
                                          <img src="../../assets/img/icon-1.png" alt="Icon" class="icon">
                                          <h3>Чем мы занимаемся?</h3>
                                      </div>
                                      <ul>
                                          <li>
                                              <span>Автоматизация заказов.</span> Обеспечиваем аптекам доступ к удобным и быстрым решениям для оформления заказов у дистрибьюторов.
                                          </li>
                                          <li>
                                              <span>Управление продажами.</span> Создаем платформы, которые помогают медицинским представителям работать с аптеками и клиниками, планировать визиты и отслеживать их эффективность.
                                          </li>
                                          <li>
                                              <span>Прозрачность процессов.</span> Внедряем системы, которые позволяют дистрибьюторам и производителям лекарственных средств лучше контролировать и анализировать продажи, а также предоставлять гибкие условия работы с клиентами.
                                          </li>
                                      </ul>
                                  </div>
                                  <div class="main-products">
                                      <div class="icon-title-wrapper">
                                          <img src="../../assets/img/icon-2.png" alt="Icon" class="icon">
                                          <h3>Наши продукты</h3>
                                      </div>
                                      <p class="intro-text">
                                          Мы предлагаем широкий спектр решений, включая:
                                      </p>
                                      <ul class="product-list">
                                          <li>Веб CRM-системы для медицинских представителей;</li>
                                          <li>Платформа для заказов препаратов аптеками у дистрибьюторов;</li>
                                          <li>Инструменты для настройки и управления скидками, включая сложные механики;</li>
                                          <li>Аналитические отчеты для управления продажами и планирования.</li>
                                      </ul>
                                      <p>
                                          Мы гордимся тем, что работаем с лидерами фармацевтического рынка, предоставляя надежные и проверенные временем решения.
                                      </p>
                                  </div>
                                  <div class="why-choose-us">
                                      <div class="icon-title-wrapper">
                                          <img src="../../assets/img/icon-3.png" alt="Icon" class="icon">
                                          <h3>Почему выбирают нас?</h3>
                                      </div>
                                      <div class="content-wrapper">
                                          <div class="column">
                                              <div class="item">
                                                  <span class="number">1</span>
                                                  <p>Глубокое понимание потребностей фармацевтического бизнеса;</p>
                                              </div>
                                              <div class="item">
                                                  <span class="number">2</span>
                                                  <p>Современные технологии, которые адаптируются под ваш бизнес;</p>
                                              </div>
                                          </div>
                                          <div class="column">
                                              <div class="item">
                                                  <span class="number">3</span>
                                                  <p>Поддержка и сопровождение на всех этапах работы;</p>
                                              </div>
                                              <div class="item">
                                                  <span class="number">4</span>
                                                  <p>PharmIT — это инновации, которые работают на вас!</p>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="red darken-1" text @click="dialogAboutUs = false">Закрыть</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-container>
                        </template>

                      </div>
                    </div>

                    <!-- Восстановить пароль -->
                    <div class="col-lg-5 col" v-else>
                      <div class="pa-7 pa-sm-12">
                        <v-img
                          max-height="100"
                          contain
                          src="../../../public/logo.png"
                        ></v-img>
                        <!-- <h2
                          class="font-weight-bold mt-4 blue-grey--text text--darken-2"
                        >
                          Вход в систему
                        </h2> -->

                        <br />
                        <br />
                        <form class="v-form">
                          <v-text-field
                            label="Логин"
                            name="login"
                            prepend-icon="mdi-account"
                            type="text"
                            v-model="account.login"
                            :rules="[rules.required]"
                            :autofocus="true"
                            :error-messages="modelState['Login']"
                            @keyup.enter="ForgotPassword"
                          />
                          <v-text-field
                            label="E-mail"
                            name="email"
                            prepend-icon="mdi-account"
                            type="text"
                            v-model="account.email"
                            :rules="rules.emailRules"
                            :autofocus="true"
                            :error-messages="modelState['Email']"
                            @keyup.enter="ForgotPassword"
                          />

                          <v-btn
                            x-small
                            text
                            color="primary"
                            style="float: right"
                            @click="show = true"
                            :disabled="loading"
                            >Вход в систему</v-btn
                          >
                          <br />
                          <br />
                          <v-btn
                            outlined
                            dark
                            block
                            color="primary"
                            @click="ForgotPassword"
                            :loading="loading"
                            depressed
                            large
                            >Восстановить пароль</v-btn
                          >
                        </form>

                        
                      </div>
                    </div>
                  </v-row>
                  <v-row>
                    <v-col class="col-12">
                      <v-img
                        class="mx-auto"
                        src="../../assets/img/astana-hub-logo.png"
                        contain
                        width="250"
                      />
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

    <!-- ZERO.kz -->
    <span id="_zero_75287">
      <noscript>
        <a href="https://zero.kz/?s=75287" target="_blank">
          <img src="https://c.zero.kz/z.png?u=75287" width="88" height="31" alt="ZERO.kz" />
        </a>
      </noscript>
    </span>
    <!-- End ZERO.kz -->
  </div>
</template>

<script>
export default {
  data: () => ({
    account: {
      login: "",
      password: "",
      email: "",
    },
    dialogAboutUs: false,
    showPassword: false,
    aboutDialog: false,
    rules: {
      required: (value) => !!value || "Поле обязательно для заполнения.",
      emailRules: [
        (v) => !!v || "Заполните поле",
        (v) => /.+@.+\..+/.test(v) || "E-mail должен быть действительным",
      ],
    },
    modelState: {},
    loading: false,
    show: true,
    managerInfo: [
      {
        FullName: 'Николай Карягин',
        Phone: '+7 747 187 40 96'
      },
      {
        FullName: 'Абилхаир Талгат',
        Phone: '+7 747 480 25 66'
      },
      {
        FullName: 'Жаскайрат Динмухамед',
        Phone: '+7 708 816 60 98'
      },
      {
        FullName: 'Единый Справочник',
        Phone: '+7 708 500 98 36'
      },
    ],
    solutions: [
      {
        title: 'PharmCenter ',
        subtitle: 'для аптек',
        description: 'Онлайн-закуп и работа с поставщиками',
        url: 'https://viortis.com/ru/it-solution/platform'
      },
      {
        title: 'PharmCenter ',
        subtitle: 'для дистрибьюторов',
        description: 'Управление заказами и взаимодействие с аптеками',
        url: 'https://viortis.com/ru/it-solution/distributor'
      },
      {
        title: 'PharmCenter ',
        subtitle: 'для производителей',
        description: 'Инструменты рекламы и продвижения',
        url: 'https://viortis.com/ru/pr-marketing/pharmcenter'
      },
    ]
  }),
  methods: {
    Authenticate() {
      this.loading = true;
      this.modelState = {};

      this.$store
        .dispatch("CREATE_TOKENS", this.account)
        .then(() => {
          this.loading = false;
          this.$router.push("/");
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.data.errors) {
            this.modelState = error.response.data.errors;
          }
          this.error = true;
        });
    },
    OpenSite() {
      window.open("https://pharmit.kz");
    },
    ForgotPassword() {
      this.loading = true;
      this.modelState = {};

      this.$store
        .dispatch("FORGOT_PASSWORD", this.account)
        .then((response) => {
          this.loading = false;
          let Message = {
            text: response,
            timeout: 7000,
            color: "warning",
            show: true,
          };
          this.$store.commit("SET_SNACKBAR", Message);
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.data.errors) {
            this.modelState = error.response.data.errors;
          }
          this.error = true;
        });
    },
  },
  computed: {
    loginForm: {
      get: function () {
        return this.$store.getters.LOGIN_FORM;
      },
      set: function () {
        this.$store.commit("SET_LOGIN_FORM", false);
      },
    },
  },
  mounted() {
    // Создаём массив, если ещё нет
    window._zero_kz_ = window._zero_kz_ || [];
    window._zero_kz_.push(['id', 75287]);
    window._zero_kz_.push(['type', 1]);
    // window._zero_kz_.push(['url_watcher', 200]);

    // Добавляем внешний скрипт
    const script = document.createElement("script");
    script.src =
      (document.location.protocol === "http:" ? "http:" : "https:") +
      "//c.zero.kz/z.js";
    script.async = true;

    document.body.appendChild(script);
  },
};
</script>

<style>
.line-info:hover td,
.line-info:hover span {
  color: rgb(33, 150, 243) !important;
}
.main-first-paragraph {
    background-color: #3c6d8c;
    color: #ffffff;
    font-weight: bold;
    font-size: 14px;
    padding: 20px;
    border-radius: 15px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    max-width: 900px;
    margin-top: 20px;
    line-height: 1.6;
    letter-spacing: 0.05em;
}
.mission-paragraph {
    color: #000000;
    font-size: 17px;
    padding: 10px;
    margin-top: 10px;
    line-height: 1.3;
}

  .mission-paragraph span {
      color: #3c6d8c;
      font-weight: bold;
  }

.main-third-paragraph {
padding-top: 10px;
padding-right: 20px;
margin-top: 0px;
line-height: 1.3;
}

.icon-title-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px; 
}

.main-third-paragraph h3 {
    color: #3c6d8c;
    text-transform: uppercase;
    font-size: 24px;
    margin-bottom: 15px;
    display: flex;
    align-items: center; 
}

.icon-link {
    margin-right: 10px;
    align-content: center;
}

.icon {
    width: 44px;
    height: 44px;
    margin-bottom: 10px;
}

.main-third-paragraph ul {
    list-style-type: none; 
    padding-left: 0; 
}

  .main-third-paragraph ul li {
      position: relative;
      margin-bottom: 10px; 
      padding-left: 20px; 
      color: #000000;
      font-size: 16px; 
  }

    .main-third-paragraph ul li::before {
        content: '•'; 
        color: #3c6d8c; 
        font-size: 18px; 
        position: absolute;
        left: 0; 
        top: 0; 
    }

    .main-third-paragraph ul li span {
        color: #5587aa;
        font-weight: bold;
    }

.main-products {
  margin-bottom: 20px;
}

.main-products h3 {
    color: #3c6d8c;
    font-size: 24px;
    text-transform: uppercase;
    margin: 0;
}

  .main-products p {
    font-size: 16px;
    color: #000000;
  }

.intro-text {
    color: #5587aa;
    font-size: 16px;
    font-style: italic;
    margin-bottom: 15px;
}

.product-list {
    font-size: 16px;
    list-style-type: none;
    padding: 0;
    margin: 0 0 10px;
    text-align: left; 
    display: inline-block; 
}

    .product-list li {
        position: relative;
        padding-left: 20px;
        margin-bottom: 10px;
        color: black;
    }

        .product-list li::before {
            content: "•";
            position: absolute;
            left: 0;
            color: #4a7fa1;
            font-size: 19px;
            line-height: 1;
        }

.why-choose-us {
  text-align: center;
  margin-bottom: 40px;
}

.why-choose-us h3 {
    color: #3c6d8c;
    font-size: 24px;
    text-transform: uppercase;
    margin: 0;
}

.content-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    text-align: left;
}

.column {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.item {
    display: flex;
    align-items: center;
    gap: 10px;
}

.number {
    font-size: 48px;
    color: #4a7fa1;
    font-weight: bold;
}

.item p {
    margin: 0;
    font-size: 16px;
    color: black;
}
.product-btn {
  border: 1px solid rgba(255, 255, 255, 0.65);
  border-radius: 6px;
  color: #ffffff;
  text-transform: none;
  justify-content: flex-start;
}

.product-btn__content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
}

.product-btn__title {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
}

.product-btn__title span {
  font-size: 10px;
}

.product-btn__subtitle {
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  opacity: 0.9;
  line-height: 1.2;
}

.product-btn__icon {
  color: #ffffff;
}

#_zero_75287{
  display: none;
}
</style>